import { useMemo } from "react";
import { useParams } from "react-router";
import { useMediasAndArticleCount } from "../hooks/useMediasAndArticleCount";
import { useStoreId } from "../../../core/auth/useLoggedInUser";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useArticleById } from "../hooks/useArticleById";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { ArticleListItemMobile, SimpleContainer } from "../styles/styles";
import { MediaPlacement } from "../Molecules/MediaPlacement";
import { Trans, useTranslation } from "@coworker/locales";
import {
  getPrimeTasks,
  getSortedMediasArticleCount,
} from "./ArticleView.helper";
import { useTasksByArticle } from "../hooks/useTasksByArticle";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FullScreenPopup from "@coworker/apprestructured/src/layout/components/FullScreenPopup/FullScreenPopup";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import { ItemListViewItemBasic } from "@coworker/apprestructured/src/media-maintenance/components/ItemListViewItemBasic/ItemListViewItemBasic";
import { AboutItemSection } from "./AboutItemSection";
import { ArticleTasksSection } from "../Organisms/ArticleTasksSection";

export function SearchedArticleView() {
  const navigate = useFixaNavigate();
  const { t } = useTranslation();
  const { productArticleId } = useParams();
  const storeId = useStoreId();

  const { data: mediasArticleCount, isFetching: racFetching } =
    useMediasAndArticleCount(productArticleId, storeId);
  const { data: searchedArticle, isFetching: saFetching } = useArticleById(
    mediasArticleCount?.[0]?.articleId
  );
  const { tasks } = useTasksByArticle(storeId, productArticleId);
  const fetching = saFetching || racFetching;

  const linkbar = useMemo(() => {
    return (
      <Linkbar
        items={[
          {
            label: t("mediaMaintenanceString"),
            to: "/mediamaintenance",
          },
        ]}
        currentLabel={searchedArticle?.itemName ?? ""}
        currentAsH1
      />
    );
  }, [searchedArticle?.itemName, t]);

  if (!fetching && !searchedArticle)
    return (
      <>
        {linkbar}
        <SimpleContainer
          $direction={"column"}
          onClick={() => {
            navigate("/mediamaintenance");
          }}
        >
          <Trans values={{ article: productArticleId }}>
            articleDoesNotExistInRoomSettingString
          </Trans>
          <FixaButton
            type={"primary"}
            text={t("goBackToRoomListingString")}
            onClick={() => {
              navigate("/mediamaintenance");
            }}
          />
        </SimpleContainer>
      </>
    );

  if (racFetching || saFetching) return <></>;

  const sortedMediasArticleCount = getSortedMediasArticleCount(
    mediasArticleCount ?? []
  );
  const primeTasks = getPrimeTasks(mediasArticleCount ?? [], tasks);

  return (
    <>
      {searchedArticle && (
        <FullScreenPopup noPadding linkbar={linkbar}>
          <FixaListView id="searched-article-list-view" size="small">
            <ArticleListItemMobile>
              <ItemListViewItemBasic
                article={searchedArticle}
                itemNo={searchedArticle.productArticleId}
              />
            </ArticleListItemMobile>

            <MediaPlacement mediasArticleCount={sortedMediasArticleCount} />

            <AboutItemSection article={searchedArticle} isFromSearch />

            <ArticleTasksSection
              mediasArticleCount={sortedMediasArticleCount || []}
              tasks={primeTasks}
            />
          </FixaListView>
        </FullScreenPopup>
      )}
    </>
  );
}
